module.exports = {
  rewardsPageEvents: {
    Rewards: {
      code: 'Page',
      events: {
        RewardsPageLoad: {
          description: 'Triggered when the offer page is viewed.',
          eventHub: {
            code: 'OnLoad',
            action: 'RewardsPage_Page loaded'
          }
        },
        RewardsPageOnClickCard: {
          description: 'Triggered when a card is clicked on the offer page.',
          eventHub: {
            code: 'OnClickCard',
            action: 'RewardsPage_Clicked [$.card] card'
          }
        }
      }
    },
    CslOfferDialog: {
      code: 'CslPopup',
      events: {
        CslOfferDialogLoad: {
          description: 'Triggered when the CSL offer popup is viewed.',
          eventHub: {
            code: 'OnLoad',
            action: 'Pop-up_Page loaded'
          }
        },
        CslOfferDialogOnClickCTA: {
          description: 'Triggered when the CTA button is clicked on the CSL offer popup.',
          eventHub: {
            code: 'OnClickCTA',
            action: 'Pop-up_Clicked CTA'
          }
        }
      }
    }
  }
};
